module.exports = __webpack_public_path__ + "static/media/ElevationImg.daee38e4.png";